import {createReducer} from '@reduxjs/toolkit'
import {Routes} from '../../../../commons/enums'
import {UPDATE_NO_EVENT_URL_OLD, internalNavigate, updateNoEventsUrl} from '../actions/navigation'
import {Navigation} from '../types/state'

const defaultState: Navigation = {
  noUpcomingEventsLinkPageUrl: undefined,
  noUpcomingEventsLinkPageId: undefined,
  route: Routes.DEFAULT,
  routeParams: {},
}

export const navigation = createReducer(defaultState, builder => {
  builder
    .addCase(updateNoEventsUrl.fulfilled, (state, action) => {
      state.noUpcomingEventsLinkPageUrl = action.payload.url
      state.noUpcomingEventsLinkPageId = action.payload.pageId
    })
    .addCase(internalNavigate, (state, action) => {
      state.route = action.payload.route
      state.routeParams = action.payload.params || {}
    })
    .addMatcher(
      action => action.type === UPDATE_NO_EVENT_URL_OLD,
      (state, action) => {
        state.noUpcomingEventsLinkPageUrl = action.payload.url
        state.noUpcomingEventsLinkPageId = action.payload.pageId
      },
    )
})
